





export const contents = [
    
  { "type": "audio", "index": 1, "name": "Scopri", "img": "/assets/background/scopri.png",  
        "info":[
        {"lang":"it","title":"Scopri" ,"txt":"Sfoglia le pagine per scoprire cosa puoi trovare all'interno del museo"}, 
        {"lang":"en","title":"Discover","txt":"Flip the pages to find out what you can find in the museum"},
        {"lang":"fr","title":"Vous découvrez","txt":"Parcourez les pages pour découvrir ce que vous pouvez trouver à l'intérieur du musée."},
        {"lang":"de","title":"Du entdeckst","txt":"Durchsuchen Sie die Seiten, um herauszufinden, was Sie im Museum finden können."},
        {"lang":"es","title":"Descubres","txt":"Navega por las páginas para descubrir lo que puedes encontrar dentro del museo."},
    ],  },
        
  { "type": "audio", "index": 2, "name": "sale", "img": "/assets/background/sQr.png",  
        "info":[
            {"lang":"it","title":"Ambientati","txt":"In ogni sala inquadra il QR Code e ascolta la voce guida"}, 
            {"lang":"en","title":"Settle in", "txt":"In each room, scan the QR Code and listen to the voice guide."},
            {"lang":"fr","title":"S'installer", "txt":"Dans chaque pièce, scannez le QR Code et écoutez le guide vocal."},
            {"lang":"de","title":"Setz dich ein", "txt":"Scannen Sie in jedem Raum den QR-Code und hören Sie sich die Sprachführung an."},
            {"lang":"es","title":"Establecerse en", "txt":"En cada sala, escanee el código QR y escuche la guía de voz."},
        ] ,  },
    
    { "type": "audio", "index": 3, "name": "Silence", "img": "/assets/background/ondaB.png",   
        "info":[
            {"lang":"it", "title":"Ascolta", "txt":"Quando trovi questo simbolo nella sala premi il pulsante e ascolta."},
            {"lang":"en", "title":"Listen ", "txt":"When you find this symbol in the room press the button and listen."},
            {"lang":"fr", "title":"Écouter", "txt":"Quand vous trouvez ce symbole dans la pièce, appuyez sur le bouton et écoutez."},
            {"lang":"de", "title":"Hören", "txt":"Wenn Sie dieses Symbol im Raum finden, drücken Sie die Taste und hören Sie zu."},
            {"lang":"es", "title":"Escuchar", "txt":"Cuando encuentres este símbolo en la habitación presiona el botón y escucha."},
        ], 
    },
    { "type": "audio", "index": 4, "name": "gps", "img": "/assets/background/gps.png",   
        "info":[
            {"lang":"it", "title":"Scopri il territorio", "txt":"Raggiungi i punti segnati sulla mappa e scopri di più."},
            {"lang":"en", "title":"Discover the territory ", "txt":"Reach the points marked on the map and find out more."},
            {"lang":"fr", "title":"Découvrez le territoire", "txt":"Atteignez les points marqués sur la carte et découvrez-en plus."},
            {"lang":"de", "title":"Entdecken Sie die Gegend", "txt":"Erreichen Sie die auf der Karte markierten Punkte und erfahren Sie mehr."},
            {"lang":"es", "title":"Descubre la zona", "txt":"Llega a los puntos marcados en el mapa y descubre más."},
        ], 
    },

    


]

